import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AgentConfirmRequest, AgentRequest, AgentResponse, AgentSuggestionResponse } from '../../../models/agent/agent.model';

/**
 * AIAgentService — facade for the AI agent write infrastructure.
 * Handles turn-based conversation, confirmation, and rejection of write operations.
 */
@Injectable({
  providedIn: 'root'
})
export class AIAgentService {
  private baseUrl: string;

  public constructor(private http: HttpClient) {
    this.baseUrl = `${environment.api.API_ENDPOINT}/ai/agent`;
  }

  /**
   * Send a user message turn to the agent.
   */
  public handleTurn(request: AgentRequest): Observable<AgentResponse> {
    return this.http.post<AgentResponse>(this.baseUrl, request);
  }

  /**
   * Confirm a pending write action.
   */
  public confirmAction(conversationId: string): Observable<AgentResponse> {
    const body: AgentConfirmRequest = { conversationId };
    return this.http.post<AgentResponse>(`${this.baseUrl}/confirm`, body);
  }

  /**
   * Reject a pending write action.
   */
  public rejectAction(conversationId: string): Observable<AgentResponse> {
    const body: AgentConfirmRequest = { conversationId };
    return this.http.post<AgentResponse>(`${this.baseUrl}/reject`, body);
  }

  /**
   * Get autocomplete suggestions (core preferences, contact fields, business units).
   */
  public getSuggestions(): Observable<AgentSuggestionResponse> {
    return this.http.get<AgentSuggestionResponse>(`${this.baseUrl}/suggestions`);
  }
}
